export default "__VITE_PUBLIC_ASSET__d2b5ace6__"